export default __webpack_public_path__ + "static/media/Skup Pula (11).09790c36.JPG";